import React from "react"
import { batch } from "@preact/signals-react"
import { Grid } from "@mui/material"

import { AppAntSwitch, AppSitesAutocomplete } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsSites() {

	const { dataInfo: sites, setDataInfo: setSites } = useAlertsDataInfo(alertsDrawerData.peek().sites || [])
	const {
		dataInfo: sameSites, setDataInfo: setSameSites
	} = useAlertsDataInfo(alertsDrawerData.peek().sameSites || false)
	
	return <Grid container sx={{ display: "flex", justifyContent: "space-between" }} spacing={1}>
		<Grid item xs={12}>
			<AppAntSwitch
				trueText="Same sites"
				checked={sameSites.value}
				disabled={alertsDrawerData.value.sameProviders}
				onChange={e => batch(() => {
					setSameSites(e.target.checked, 'sameSites')
					setSites([], 'sites')
				})}
			/>
		</Grid>
		<Grid item xs={12}>
			<AppSitesAutocomplete
				value={sites.value}
				onChange={e => setSites(e.target.value, 'sites')}
				disabled={sameSites.value}
			/>
		</Grid>
	</Grid>
}